import { InputGroup, InputRightElement, Textarea, HStack } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import FancyButton from './buttons';
import SendIconButton from './SendIconButton';
import { useBreakpointValue } from "@chakra-ui/react";
function ChatInput({
  roomId, talkTo, userId, data, publish, setMessageHistory, convId, aiMsgIndexRef
}) {
  const [text, setText] = useState("");
  const [isComposing, setIsComposing] = useState(false); // 免中文輸入法誤送出
  const [rows, setRows] = useState(1);
  const sendMessage = useCallback(() => {
    const msg = text.trim();
    if (!msg) return;

    let _destination, _body;

    if (talkTo === "") {
      _destination = `/app/chat.send/room.${roomId}`;
      _body = msg;
    }
    else if (talkTo === "aiUser") {
      if(aiMsgIndexRef.current != null)
        return;
      if(text == '畫柴犬'){
        _destination = "/app/chat.send.private";
        _body = JSON.stringify({ text: msg, sender: talkTo });
      }
      else{
        _destination = '/app/ai.start';
        _body = JSON.stringify({ convId, userId, prompt: text, roomId });
      }
      setMessageHistory(prev => [...prev, { userId: userId, text: msg, toUserId: talkTo }]);
    } else {
      _destination = "/app/chat.send.private";
      _body = JSON.stringify({ text: msg, sender: talkTo });
      setMessageHistory(prev => [...prev, { userId: userId, text: msg, toUserId: talkTo }]);
      // setMessageHistory(prev => [...prev, `${name}對${targetName}說：${msg}`]);
    }

    publish(_destination, _body);
    setText("");
  }, [text, talkTo, roomId, userId, data, publish, setMessageHistory]);

  const handleKeyDown = (e) => {
    if (isComposing) return;                  // 組字中，不送出
    if (e.key === "Enter") {                  // Input 單行，Enter = 送出
      e.preventDefault();
      sendMessage();
    }
  };


  const handleChange = (e) => setText(e.target.value);
  const showButton = useBreakpointValue({ base: false, md: true });
  return (
    <HStack align="end" spacing={3}>
      <Textarea
        name="text"
        value={text}
        rows={rows}
        background="#fff"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={() => setIsComposing(false)}
        placeholder="輸入訊息..."
        enterKeyHint="send"        // 手機虛擬鍵盤顯示「送出」
        pr={showButton ? "6rem" : "0"}  // 預留右側按鈕空間，避免文字被擋
        onFocus={() => setRows(3)}
        onBlur={() => setRows(1)}
      />
    
      {showButton ? (
        <FancyButton
          delegate={sendMessage}
          text="送出"
          height="2rem"
          minWidth="5rem"
        />
      ) : (
        <SendIconButton onClick={sendMessage} />
      )}

     
    </HStack>
  );
}


export default ChatInput;